module.exports = "{{#if maxLength}} <input type=Password class=\"input js-input\" placeholder={{placeholder}} maxlength={{maxLength}}> {{else}} <input type=Password class=\"input js-input\" placeholder={{placeholder}}> {{/if}} <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_text\"><use xlink:href=#icon-text /> </svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/passwordEditor.hbs
// module id = 692
// module chunks = 0